import React from 'react';
import './IRAAutoMaxContributionsModal.scss';
import { currency } from '../../../utils/utils';
import { getMonthName } from 'src/utils/dates/date-utility';
const IRAAutoMaxContributionsModal = ({ contributionData }) => {
  const formatContributionDate = (date) => {
    const temp = date.split('T')[0].split('-');
    return `${getMonthName(getMonthName(parseInt(temp[1]) - 1).toUpperCase())}
      ${parseInt(temp[2])}, ${temp[0]}`;
  };
  return (
    <div className="auto-max-contribution-modal">
      <div className="ira-contribution-header">
        Your IRA AutoMax Contribution Schedule
      </div>
      <div className="automax-contribution-row titles-row">
        <div className="automax-contribution-fund-title">Fund</div>
        <div className="contribution-info-row contribution-info">
          <div className="automax-contribution-date-title">
            Transaction Date
          </div>
          <div className="automax-contribution-amount-title">Amount</div>
        </div>
      </div>
      {contributionData.map((account, i) => (
        <div key={i + 1} className="automax-contribution-row">
          <div className="automax-contribution-fund">
            <div className="account-type">{account.accountType}</div>
            <span className="account-fund-fundName">{account.fundName}</span>
            <span className="account-fund-ticker">{account.ticker}</span>{' '}
            <span className="account-fund-user">{account.agreementNumber}</span>
          </div>
          <div className="contribution-info-row">
            {account.contributions
              .filter((transaction) => transaction.amount !== 0)
              .map((contribution, i) => (
                <div key={i + 1} className="contribution-info">
                  <div className="automax-contribution-date">
                    {formatContributionDate(contribution.withdrawalDate)}
                  </div>
                  <div className="automax-contribution-amount">
                    {currency(contribution.amount)}
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default IRAAutoMaxContributionsModal;
